import { render, staticRenderFns } from "./agendamento-medico.vue?vue&type=template&id=95eea150&scoped=true"
import script from "./agendamento-medico.vue?vue&type=script&lang=ts"
export * from "./agendamento-medico.vue?vue&type=script&lang=ts"
import style0 from "./agendamento-medico.vue?vue&type=style&index=0&id=95eea150&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95eea150",
  null
  
)

export default component.exports